import ajax from '@/utils/request'
import config from '../config'
import utils from '../utils'

const headers = {
  'Es-Type': 'es'
}

/**
 * ArticleService
 * @module service/Account
 */
export default {
  /**
   * 登录
   * @param {Number}    country   手机国际区号
   * @param {Mobile}    cellphone 手机号
   * @param {Email}     email     邮箱地址
   * @param {Password}  password  密码 6-16 个字符
   * @param {String}    platform  平台 [1:ios, 2:android, 3:web, 4:小程序]
   * @param {String}    appid     应用id [1:极客时间, 2:企业帐号]
   * @param {String}    captcha   图形验证码，4位
   */
  signin (data) {
    const postData = Object.assign({
      platform: 3,
      appid: 2
    }, data, {
      source: utils.getQueryString(window.location.href, 'gk_source')
    })

    postData.data = postData.data || window.getNVCVal()

    if (postData.cellphone) {
      postData.cellphone = postData.cellphone - 0
    }

    /**
     * 企业信息
     * @param {Object}  res          数据
     * @param {String}  res.uid      用户 uid
     * @param {Email}   res.email    用户登录邮箱
     * @param {String}  res.name     企业名称
     * @param {String}  res.address  企业地址
     * @param {Mobile}  res.mobile   联系人手机号
     * @param {String}  res.contact  联系人姓名
     */
    return ajax({
      host: config.account,
      url: 'es/v2/ticket/login',
      data: postData
    })
  },
  /**
   * 短信登录
   * @param {Number}    country   手机国际区号
   * @param {Mobile}    cellphone 手机号
   * @param {Password}  password  密码 6-16 个字符
   * @param {String}    platform  平台 [1:ios, 2:android, 3:web, 4:小程序]
   * @param {String}    appid     应用id [1:极客时间, 2:企业帐号]
   * @param {String}    code      验证码，6位
   * @param {String}    captcha   图形验证码，4位
   */
   smsSignin (data) {
    const postData = Object.assign({
      platform: 3,
      appid: 2
    }, data, {
      source: utils.getQueryString(window.location.href, 'gk_source')
    })

    postData.data = postData.data || window.getNVCVal()
    postData.cellphone = postData.cellphone - 0

    /**
     * 企业信息
     * @param {Object}  res          数据
     * @param {String}  res.uid      用户 uid
     * @param {Email}   res.email    用户登录邮箱
     * @param {String}  res.name     企业名称
     * @param {String}  res.address  企业地址
     * @param {Mobile}  res.mobile   联系人手机号
     * @param {String}  res.contact  联系人姓名
     */
    return ajax({
      host: config.account,
      url: 'es/v2/sms/login',
      data: postData
    })
  },
  /**
   * 发送手机验证码
   * @see https://yapi.geekbang.org/project/295/interface/api/13216
   * @fires es/v2/register/code:sendMobileCode
   * @param {String}  type       发送验证码的类型 [register:注册时,forget:忘记密码时]
   * @param {Number}  cellphone  手机号
   * @param {Number}  country    国际区号
   * @param {String}  captcha    验证码
   */
  sendMobileCode (type, country, cellphone, value, data) {
    let url = ''
    const postData = {
      country: country - 0,
      cellphone: cellphone - 0,
      data: data || window.getNVCVal()
    }

    if (value) {
      postData.captcha = value
    }

    switch (type) {
      case 'register':
        url = 'es/v2/register/code'
        break
      case 'sms':
        url = 'es/v2/sms/code'
        break
      case 'forgot':
        url = 'es/v2/forgot/codecellphone'
        break
      case 'bind':
        url = 'es/v2/cellphone/code'
        break
      default:
        break
    }

    /**
     * 执行获取数据导出状态的接口
     * @event es/study/export-status-list:getExportStatus
     * @returns {Array<Object>}     res          返回数据
     * @returns {Number}            res.id       数据 ID
     * @returns {Number}            res.status   文件状态 [-1:计算中,1:已完成,-2:已过期]
     */
    return ajax({
      host: config.account,
      url: url,
      data: postData
    })
  },
  /**
   * 验证验证码
   * @param {String}  type  [signin: 登录, register: 注册]
   * @param {String}  value  验证码
   */
   checkCaptcha (type, value) {
    let url = ''

    switch (type) {
      case 'signin':
        url = 'es/v2/check/ticket'
        break
      case 'register':
        url = 'es/v2/check/register'
        break
      case 'sms':
        url = 'es/v2/check/smslogin'
        break
      case 'forgot':
        url = 'es/v2/check/forgot'
        break
      case 'bind':
        url = 'es/v2/check/bindcellphone'
        break
      default:
        break
    }

    return ajax({
      host: config.account,
      url: url,
      data: {
        captcha: value
      }
    })
  },
  /**
   * 获取企业信息
   * @see https://yapi.geekbang.org/project/122/interface/api/16717
   * @fires es/company/info:getCorporateInfo
   */
   getCorporateInfo () {
    /**
     * 执行获取企业信息的接口
     * @event es/company/info:getCorporateInfo
     * @returns {Object}    res                         数据
     * @returns {Email}     res.email                   用户登录邮箱
     * @returns {String}    res.name                    企业名称
     * @returns {String}    res.address                 企业地址
     * @returns {Mobile}    res.mobile                  联系人手机号
     * @returns {String}    res.contact                 联系人姓名
     * @returns {String}    res.type                    用户类型 [1:极客时间c端, 2:企业服务]
     * @returns {String}    res.user_sub_type           登录场景 [1:极客时间, 2:企业微信, 3:dingding,4:飞书]
     */
    return ajax({
      host: config.bizHost,
      // url: 'es/v2/user'
      url: 'es/company/info',
      headers
    }).then(res => {
      res.needModify = false

      res = Object.assign(res, res.company_info)

      res.industry = res.industry || ''
      res.size = res.size || ''
      res.province = res.province || ''
      res.city = res.city || ''

      switch (res.user_sub_type | 0) {
        // 极客时间
        case 1:
          res.platformEnter = 'base'
          break
        // 企业微信
        case 2:
          res.platformEnter = 'wechat'
          break
        // 钉钉
        case 3:
          res.platformEnter = 'dingding'
          break
        // 飞书
        case 4:
          res.platformEnter = 'feishu'
          break
        default:
          res.platformEnter = 'base'
          break
      }

      return res
    })
  },

  /**
   * 登出
   */
  logout () {
    return ajax({
      host: config.account,
      url: 'es/v2/ticket/delete',
      headers
    })
  }
}
